<div *ngIf="blogChannel">
  <div class="add-script-blog row">
    <div class="col-md-6">
      <div class="heading-bottom">{{'influencer_settings.heading' | translate:{blogUrl: blogChannel.handle} }}</div>
    </div>
    <div class="col-md-6">
      <div class="d-flex flex-auto align-items-center justify-content-end">
        <button class="button red" (click)="cancelAddScript()">{{'common.btn.cancel' | translate}}</button>
        <button class="button green btn-finish" (click)="finishAddScript()">{{'common.btn.finish' | translate}}</button>
      </div>
    </div>
  </div>

  <div class="add-script-form bottombar-content form-content flex-auto">
    <div class="row">
      <div class="col-md-6">
        <div class="add-script-area">
          <div class="note">{{'influencer_settings.note' | translate}} <span>{{'influencer_settings.note_web' | translate}}</span> {{'influencer_settings.note_2' | translate}}</div>
          <div class="script-tooltip" id="scriptTooltip">
            <span class="tooltiptext">{{copyScriptTooltip}}</span>
            <textarea id="scriptContent" readonly (click)="copyScript()" (mouseenter)="openTooltip()" (mouseleave)="closeTooltip()"><script type= “text/javascript” src=“http://iptracker.getachoo.com/aip_tracker.js?v=2” async></script></textarea>
          </div>
          <div class="help">{{'influencer_settings.help' | translate}}</div>
          <div class="note">{{'influencer_settings.guide' | translate}}</div>
          <div class="platform-logo">
            <img src="./assets/images/Wp.png" alt="" width="32">
            <img src="./assets/images/Blogger_Dark.png" alt="" width="32">
            <img src="./assets/images/Tumblr.png" alt="" width="32">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="d-flex flex-auto align-items-center justify-content-end">
          <div class="update-area">
            <div class="update-area-alert">{{'influencer_settings.warning' | translate}}</div>
            <div class="form-status red"></div>
            <div class="intro">
              {{'influencer_settings.intro' | translate}}
            </div>
            <button class="btn-update-script" (click)="finishAddScript()">{{'common.btn.update' | translate}}</button>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/add-script-blog/add-script-blog.component.html